'use client';

import * as Sentry from "@sentry/nextjs";
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import PageLayout from '@/components/PageLayout';
import HeadingLarge from '@/components/text/heading-large';

export default function Error({ error, reset }) {
  const t = useTranslations('Error');

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <PageLayout>
      <div className='flex flex-col justify-center items-center py-64'>
        <HeadingLarge>Unexpected Error</HeadingLarge>
        {t.rich('description', {
          p: (chunks) => <p className="mt-4">{chunks}</p>,
          retry: (chunks) => (
            <button
              className="text-black underline underline-offset-2"
              onClick={reset}
              type="button"
            >
              {chunks}
            </button>
          )
        })}
      </div>
    </PageLayout>
  );
}
